import { ExclamationCircleIcon } from '@heroicons/react/20/solid'
import { FC, ReactNode } from 'react'

import { cn } from '@/app/utils'

type Props = {
  Icon?: FC
  message?: ReactNode
  className?: string
  iconClassName?: string
  messageClassName?: string
  dataTestId?: string
}

const AppInputMessage: FC<Props> = ({
  Icon = ExclamationCircleIcon,
  message,
  className,
  iconClassName = 'text-red-70',
  messageClassName = 'text-red-70',
  dataTestId
}) =>
  message && (
    <div
      data-testid={dataTestId}
      className={cn('mt-4 flex items-center gap-8 font-pro text-16', className)}
    >
      <Icon className={cn('w-20 flex-shrink-0', iconClassName)} />
      <p className={messageClassName}>{message}</p>
    </div>
  )

export default AppInputMessage
